<template>
  <!-- comment -->
  <div class="main_BoxChart">
    <!-- <div class="d-flex justify-start text-h6 fonts-weight-bold">ความคิดเห็น</div> -->
    <div class="ChatMessage_BoxChat" id="ChatMessage_BoxChat">
      <!-- <div class="green pa-5"> -->
      <v-row class="pa-0 ma-0">
        <v-col
          cols="12"
          v-for="(i, idx) in localItems"
          :key="`${uuid}-${idx}`"
          class="pa-0 ma-0 pb-1"
        >
          <v-comment
            :item.sync="localItems[idx]"
            @update="onUpdate"
          >
          </v-comment>
        </v-col>
      </v-row>

      <!-- <v-col
        class="ChatMessage_BoxChat"
        v-for="ccc in items"
        v-bind:key="ccc.comment_id"
      >
        {{ ccc }} -->
      <!-- <comment
          v-model="ccc"
          v-on:event_child="eventChild"
          :hospital_id="hospital_id"
          :job_id="job_id"
        ></comment> -->
      <!-- </v-col> -->
      <!-- </div> -->
    </div>

    <div class="input_BoxChat">
      <div class="grid-item">
        <input
          style="width: 100%; height: 100%"
          type="text"
          v-model="commentText"
          @keyup.enter="onCreate"
          placeholder="เขียนความคิดเห็น..."
        />
      </div>
      <div class="grid-item">
        <v-btn icon class="" @click="onCreate" :disabled="commentText == ''">
          <v-icon class="blue--text">mdi-send</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import vComment from './Comment.vue'
import { uuid } from 'vue-uuid'
import { mapGetters } from 'vuex'
export default {
  props: {
    items: {
      // NOTE Array ของ comment สำหรับ Job
      type: Array,
      default: () => []
    },
    hospital_id: {
      type: String
      // default: 'Untitled'
    },
    job_id: {
      type: String
    },
    currentUser: {
      type: String
    }
  },
  computed: {
    ...mapGetters(['storeGetUserInfo']),
    localItems: {
      get () {
        return this.items
      },
      set (val) {
        this.$emit('update:items', val)
        return val
      }
    }
  },
  components: {
    // VueJSONQueryBuilder,
    // EuiSearch,
    vComment
  },

  data () {
    return {
      defaultCommentItem: {
        user_id: '',
        type: '',
        message: '',
        image: '',
        sticker: '',
        comments: [],
        agrees: []
      },
      // commentsData: [
      //   {
      //     comment_id: '8e8a52d8-ba54-416d-964e-3588998aceb6',
      //     user_id: 'Dolores',
      //     message: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate iusto temporibus ut vero aspernatur dolor animi hic impedit saepe, incidunt eaque nihil fugit blanditiis, tenetur dicta? Omnis id laudantium repellat?',
      //     comments: [
      //       {
      //         comment_id: 2,
      //         user_id: 'Peter',
      //         message: 'Illum repudiandae corrupti voluptas dolores ratione excepturi dolorum quaerat quidem accusamus hic ullam cumque nesciunt possimus earum laudantium molestias magni nostrum dolorem, ab temporibus architecto pariatur id quam porro. Amet!',
      //         comments: []
      //       },
      //       {
      //         comment_id: 3,
      //         user_id: 'Potter',
      //         message: 'Ex at eveniet cupiditate sint fugiat dolorum, soluta asperiores reiciendis. Dolorum earum expedita minima suscipit animi modi sed, quo aliquid placeat neque, excepturi maiores deserunt praesentium non iste. Perferendis, aspernatur?',
      //         comments: [
      //           {
      //             comment_id: 4,
      //             user_id: 'Lily',
      //             message: 'Saepe labore, ipsam temporibus, consectetur, dolorem neque incidunt iusto sint quia nulla quaerat veritatis maxime aliquid debitis qui doloribus? Veritatis accusamus consectetur, natus enim ad voluptates modi officia aspernatur dolores?',
      //             comments: []
      //           }
      //         ]
      //       }
      //     ]
      //   },
      //   {
      //     comment_id: 5,
      //     user_id: 'Draco',
      //     message: 'Laudantium ullam, repellat commodi saepe placeat nobis aperiam! Pariatur fugiat, quas, minus, accusamus quam amet laborum recusandae architecto reiciendis nemo tempora non consequatur esse ea. Doloribus deleniti reprehenderit deserunt officia?',
      //     comments: []
      //   },
      //   {
      //     comment_id: 6,
      //     user_id: 'Lucius',
      //     message: 'Molestiae, eius perspiciatis excepturi aut reiciendis dolor quae ipsam. Repellendus nihil facilis est fugiat, voluptatum illum necessitatibus expedita soluta ipsum aliquid odit repudiandae ex, deleniti harum vitae ea eius nulla.',
      //     comments: []
      //   }
      // ],
      commentsData: this.localItems,
      // commentText: '',
      // currentUser: this.storeGetUserInfo.user_id,
      nextId: 30,
      lastParent: null,
      // commentd
      isGroupRolledUp: true,
      isReplying: false,
      commentText: '',
      // first_name: 'Nattida',
      // last_name: 'phawandee',
      uuid: uuid.v4(),
      pathComment: {}

      // items: [{ a: 1 }, { a: 2 }]
    }
  },

  watch: {
    items: {
      handler () {
        this.onScroll2Bottom()
      },
      immediate: true,
      deep: true
    }
  },
  mounted () {
    this.$EventBus.$on('event_child', (val) => {
      this.eventChild(val)
    })
    this.$EventBus.$on('delete', (val) => {
      this.deleteComment(val)
    })
  },
  methods: {
    async eventChild (data) {
      // console.log(data)
      // this.pathComment = {}
      this.lastParent = data.parent_id
      const item = {
        // comment_id: this.nextId,
        first_name: this.storeGetUserInfo.first_name,
        last_name: this.storeGetUserInfo.last_name,
        user_id: this.currentUser,
        message: data.message,
        comments: []
      }
      const comment = this.recursiveFind(this.localItems, data.parent_id)
      if (comment) {
        // push เข้า comments ย่อย
        comment.comments.push(item)
        // ไล่เช็ค Path แล้วโยนทั้งก้อนเข้า Api
        for (let i = 0; i < this.localItems.length; i++) {
          this.getPath(this.localItems[i], data.parent_id)
        }
        // this.UpdateJobComment(this.pathComment)
        this.$emit('createSub', this.pathComment)
        this.nextId++
      }
    },
    getPath (model, id, path) {
      if (!path) {
        path = []
      }
      if (model == null) {
        return
      }
      if (model.comment_id === id) {
        // console.log(model, path)
        this.pathComment = path[0]
        if (typeof this.pathComment !== 'undefined') {
          return this.pathComment
        } else {
          this.pathComment = model
          return this.pathComment
        }
      }
      // กรณีทรามีลูกให้วนหา
      if (model.comments) {
        // model.comments.forEach(child => this.getPath(child, id, [...path, model.comment_id]))
        model.comments.forEach(child => this.getPath(child, id, [...path, model]))
      }
    },
    onCreate () {
      // NOTE เป็น Method สำหรับส่งข้อมูลที่ใช้ในการสร้าง Root Comment ไปยัง Parent
      this.$emit('create', {
        ...this.defaultCommentItem,
        ...{
          type: 'message',
          message: this.commentText
        }
      })
      this.commentText = ''
    },
    onUpdate () {
      this.$emit('update', {})
    },
    onDelete (val) {
      console.log('dd')
      console.log(val)
      // this.$emit('delete', {})
    },
    onScroll2Bottom () {
      // NOTE ทำให้ข้อความใหม่อยู่ด้านล่างเสมอ
      // NOTE ต้อง Delay การทำงานไว่เพราะทำเร็วกว่าการยิง API และ Append Element
      setTimeout(() => {
        const ele = document.getElementById('ChatMessage_BoxChat')
        if (ele) ele.scrollTop = ele.scrollHeight
      }, 500)
    },
    recursiveFind (comments, id) {
      if (comments) {
        for (let i = 0; i < comments.length; i++) {
          if (comments[i].comment_id === id) {
            return comments[i]
          }
          const found = this.recursiveFind(comments[i].comments, id)
          if (found) return found
        }
      }
    },
    async addComment () {
      if (this.commentText.trim() === '') return false
      const item = {
        // comment_id: this.nextId,
        user_id: this.currentUser,
        message: this.commentText,
        comments: []
      }
      const payload = {
        job_id: this.job_id,
        hospital_id: this.hospital_id,
        // comment_id: this.nextId,
        user_id: this.currentUser,
        type: 'message',
        message: this.commentText,
        image: '',
        sticker: '',
        comments: [],
        agrees: []
      }
      this.CreateJobComment(payload)
      // push เข้า comments หลัก
      // ส่วนนี้ทำ emit ค่าทีหลัง
      this.localItems.push(item)
      // this.nextId++
      this.commentText = ''
    },
    deleteComment (val) {
      // console.log(val)
      this.pathComment = {}
      const payload = {
        job_id: this.job_id,
        hospital_id: this.hospital_id,
        comment_id: val
      }
      // หา index ที่ต้องการลบ
      let findIndexDeleteComment = ''
      findIndexDeleteComment = this.localItems.findIndex(object => {
        return object.comment_id === val
      })
      if (findIndexDeleteComment !== -1) {
        // console.log('Main comment')
        // this.DeleteJobComment(payload)
        this.$emit('deleteMain', payload)
        this.localItems.splice(findIndexDeleteComment, 1)
      } else {
        // console.log('Sub comment')
        // ไล่เช็ค Path แล้วโยนทั้งก้อนเข้า Api
        for (let i = 0; i < this.localItems.length; i++) {
          this.getPath(this.localItems[i], val)
        }
        // หา path ของ comment ที่ click
        let localItemsTemp = []
        localItemsTemp.push(this.pathComment)
        // ลบ ก้อนที่ click
        localItemsTemp = this.recursiveDeleteComment(localItemsTemp, val)
        // console.log(this.recursiveDeleteComment(this.localItems, val))
        // this.UpdateJobComment(localItemsTemp[0])
        this.$emit('deleteSub', localItemsTemp[0])
      }
    },
    recursiveDeleteComment (arr, id) {
      return arr
        .filter((el) => el.comment_id !== id)
        .map((el) => {
          if (!el.comments || !Array.isArray(el.comments)) return el
          el.comments = this.recursiveDeleteComment(el.comments, id)
          return el
        })
    }
  }
}
</script>

<style lang="css" scoped>
.main_BoxChart {
  position: relative;
  /* height: 200px; */
  height: 100%;
  /* background: #e5e5; */
  padding: 0;
  margin: 0;
  width: 100%;
}
.ChatMessage_BoxChat {
  position: absolute;
  /* height: 80%; */
  height: calc(100% - 52px - 0.7rem);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0;
  margin: 0;
  width: 100%;
}
.input_BoxChat {
  position: absolute;
  width: 100%;
  bottom: 0rem;
  background: #eeeeeed2;
  border-radius: 10px;
  /* height: 30%; */
  /* -webkit-box-shadow: 2px 5px 16px 0px #a1a1a1,
    5px 5px 15px 5px rgba(0, 0, 0, 0);
  box-shadow: 2px 5px 16px 0px #a1a1a1, 5px 5px 15px 5px rgba(0, 0, 0, 0); */
  display: grid;
  grid-template-columns: 85% 15%;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
textarea:focus,
input:focus {
  outline: none;
}
.input_BoxChat .grid-item:nth-child(1) {
  padding-left: 1rem;
}

.effect_BoxChat {
  /* border: 1px solid #ccc;
  border-radius: 10px; */
  background: transparent;
  width: 100%;
}
.test {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 9px 15px;

  position: absolute;
  width: 201px;
  height: 56px;
  left: 753px;
  top: 1214px;

  background: #f0f2f5;
  border-radius: 18px;
}
.listMessage_BoxChat {
  /* background: #F0F2F5;
  padding: 5px;
  border-radius: 5px; */

  display: flex;
  /* align-items: flex-start; */
  padding: 9px 15px;

  /* position: absolute; */
  width: 50%;
  /* max-width: 50%; */
  min-width: 201px;
  height: 100%;
  min-height: 56px;
  /* width: 201px; */
  /* height: 56px; */
  /* left: 753px; */
  /* top: 1214px; */
  background: #f0f2f5;
  border-radius: 18px;

  /* width: 201px;
  height: 56px; */
}
.listMessage_BoxChat2 {
}
.compaint-description {
  display: flex;
  flex-wrap: wrap;
  /* flex-wrap: wrap; */
  /* max-width: 200px; */
  /* width: 100%; */
  /* padding: 3px; */
  max-width: 50%;
  font-size: 20px;
  font-weight: 400;
}
.userNameText {
  /* background: red; */
  font-family: "Segoe UI";
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  /* line-height: 20px; */
}
.commentText {
  font-family: "Segoe UI";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
}
.description-text {
  /* max-width: 200px;
  width: 100%; */
  /* 100%ของcompaint-description */
  max-width: 100%;
  min-width: 100px;
  height: auto;

  background: darkgoldenrod;
  margin: 5px;
}
/* scrollbar */
::v-deep ::-webkit-scrollbar {
  display: block;
  width: 8px;
}

/* Track */
/* ::v-deep ::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
} */

/* Handle */
::v-deep ::-webkit-scrollbar-thumb {
  /* background: red; */
      background: #c3c8d0d0;
  border-radius: 8px;
}

/* Handle on hover */
::v-deep ::-webkit-scrollbar-thumb:hover {
  background: #acb0b8d0;
}
</style>
